module.exports = __webpack_public_path__ + "img/error-accessories.19cd1fe9.svg";